import { createAction } from '@reduxjs/toolkit'

export const setTabBarHeightAction = createAction<number>('layout/set-tab-bar-height')
